import Store from '@/store'

export class AudienceTestStoreUtils {

    static fetchAudienceTests() {
        return Store.dispatch("audience-test-store/fetchAudienceTests");
    }

    static newABTest(data) {
        return Store.dispatch("audience-test-store/newABTest", data);
    }

    static updateABTest(data) {
        return Store.dispatch("audience-test-store/updateABTest", data);
    }

    static deleteABTest(testId) {
        return Store.dispatch("audience-test-store/deleteABTest", testId);
    }

    static setABTestActive(testId) {
        return Store.dispatch("audience-test-store/setABTestActive", testId);
    }

    static getABTests() {
        return Store.getters["audience-test-store/getABTests"];
    }

    static getActiveTest() {
        return Store.getters["audience-test-store/getActiveTest"];
    }

    static getAudiences() {
        return Store.getters["audience-test-store/getAudiences"];
    }

    static getCustomAudiences() {
        return Store.getters["audience-test-store/getCustomAudiences"];
    }

}